// extracted by css-extract-rspack-plugin
export default {"illustration":"IhO4U9"};